import React from 'react';
import { Box } from '@mui/material';
import { CurrencyInputField } from 'components/form';
import { FieldPath, useFormContext } from 'react-hook-form';
import { ListingForm } from 'components/shared/TableListing/types';

import { BasePrice, Charge } from '../../../types';

interface Props {
  index: number;
  disabled?: boolean;
  type: keyof BasePrice;
}

export const ChargeValueCell = ({ index, type, disabled }: Props) => {
  const inputName = `bodyFields.${index}.price.${type}` as FieldPath<ListingForm<Charge>>;

  const { control } = useFormContext<ListingForm<Charge>>();

  return (
    <Box>
      <CurrencyInputField
        allowNegative
        name={inputName}
        control={control}
        textFieldProps={{ disabled, variant: 'outlined' }}
      />
    </Box>
  );
};
